import { Button, InputNumber, notification } from "antd"
import Modal from "antd/lib/modal"
import { ModalFuncProps } from "antd/lib/modal/interface"
import React, { FunctionComponent, useEffect, useState } from "react"
import { PositionsService } from "../api/services.gen"
import { useParams } from "react-router"
import { PositionDto } from "../api"

type PositionParams = { id: string }

const PositionPage:FunctionComponent<{}> = (props) => {
  const params = useParams<PositionParams>()

  const [position, setPosition] = useState<PositionDto>()
  const [positionPrice, setPositionPrice] = useState<number>(0)
  const [modal, contextHolder] = Modal.useModal();

  const fetchPosition = async () => {
    const position = await PositionsService.getPosition({ positionId: params.id! })
    setPosition(position.position)
  }
  useEffect(() => {
    fetchPosition()
  }, [params.id])

  const modalDelete: ModalFuncProps = {
    title: 'Are you sure?',
    content: 'This will set the position as closed. Is this already sold on broker?',
    onOk: async () => {
      try {
        const res = await PositionsService.closeManuallyPosition({
          positionId: params.id!,
          requestBody: {
            price: positionPrice
          }
        })
        notification.success({
          message: 'Position closed',
          description: `Position set as sold`
        })
        // TODO: go back
      } catch (e: any) {
        console.error(e)
        notification.error({
          message: 'Error',
          description: e.toString()
        })
      }
    }
  }

  return <>
    <pre>{JSON.stringify(position, null, 2)}</pre>
    <InputNumber onChange={(v: number | null) => setPositionPrice(v!)} value={positionPrice} />
    <Button onClick={() => modal.confirm(modalDelete)}>Close manually</Button>

    {contextHolder}
  </>
}

export { PositionPage }